import { Component, OnInit, HostListener, Inject, ViewEncapsulation } from '@angular/core';
import { UserModel } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { MessageService } from 'primeng/api';
import { Location } from '@angular/common';
import { CountryService } from 'src/app/services/country.service';
import { Country } from 'src/app/models/country.model';
import { EngagementService } from 'src/app/services/engagement.service';
import { HttpClient } from '@angular/common/http';
import { InfraService } from 'src/app/services/infra.service';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { CryptoUtils, InteractionRequiredAuthError, Logger, LogLevel } from 'msal';
import { UserIdleService } from 'angular-user-idle';
import { filter, Subject, Subscription, takeUntil } from 'rxjs';
import { Sharedservice } from 'src/app/shared-components/shared.service';
import { EngagementModel } from 'src/app/models/engagement.model';
import { Router } from '@angular/router';
import { RegionService } from 'src/app/services/region.service';
import { AuthenticationResult, Configuration, EventMessage, EventType, InteractionStatus, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import * as msal from "@azure/msal-browser";
import { SettingsProvider } from 'src/app/settings-provider';
import { environment } from 'src/environments/environment';
import { DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS } from '@azure/msal-browser/dist/config/Configuration';

@Component({
  selector: 'app-selectregion',
  templateUrl: './selectregion.component.html',
  styleUrls: ['./selectregion.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SelectregionComponent implements OnInit {
  title = 'TD Databook';
  display: boolean;
  countryLoaded: boolean;
  countryId: number;
  userModel: UserModel = new UserModel();
  forAuthorizedUser = true;
  forUnAuthorizedUser = false;
  loadspinner = false;
  selectedInfra : any = '0,0,0'; // countryId,templateId,RegionId
  isregionselected = false;
  countrylist: Country[];
  countryAcceptability: string;
  isCountryAllowed: boolean;
  isNotChrome = false;
  countryDropdownList = [];
  viewEngagementCountryId: any;
  viewEngagementEngagementId: any;
  private subscription: Subscription;
  private readonly _destroying$ = new Subject<void>();
  country: string;
  loginDisplay = false;
  isIE =
    window.navigator.userAgent.indexOf("MSIE ") > -1 ||
    window.navigator.userAgent.indexOf("Trident/") > -1;



  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private infraService: InfraService, private engagementService: EngagementService, private router: Router,
    private msalService: MsalService, private userIdle: UserIdleService,
    private location: Location, private messageService: MessageService, private http: HttpClient,
    private countryService: CountryService, private readonly broadcastService: MsalBroadcastService,
    private regionService: RegionService, private settingsProvider: SettingsProvider) { }

  onChange(countryValue) {
    this.countryId = +countryValue.value.split(',')[0];
    const country = this.countrylist.find(el => el.Id === this.countryId);

    this.countryAcceptability = country['Acceptability'];
    if (this.countryAcceptability !== '' && this.countryAcceptability !== 'Not allowed') {
      this.isCountryAllowed = true;
    } else {
      this.isCountryAllowed = false;
    }
  }

  ngOnInit() {
    console.log("inside selectregion");
    this.viewEngagementCountryId = localStorage.getItem('WBcountryId');
    this.viewEngagementEngagementId = localStorage.getItem('WBEngagementId');

    if ((navigator.userAgent.indexOf('Chrome') == -1)
      || (navigator.userAgent.indexOf('OPR') == 116)) {
      this.isNotChrome = true;
    } else {
      this.msalService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
      this.broadcastService.msalSubject$
        .pipe(
          filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED),
        )
        .subscribe(async (result: EventMessage) => {
          console.log(result, "msalSubject");
          if (this.msalService.instance.getAllAccounts().length === 0) {
            console.log(result, " if getAllAccounts");
           window.location.pathname = "/";
           await this.signIn('dba', 0, '');
          } else {
            console.log(result, "else getAllAccounts");
            this.signIn('dba', 0, '');
          }
        });

      this.broadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
          this.signIn('dba', 0, '');
          //this.checkAndSetActiveAccount();
        });

      // this.broadcastService.msalSubject$.pipe(filter((message: EventMessage) => message.eventType === EventType.LOGIN_FAILURE),
      //   takeUntil(this._destroying$)).subscribe((message: EventMessage) => {
      //     console.log(message, 'fail');
      //     this.signIn('dba', 0, '');
      //   });

    
      this.broadcastService.msalSubject$.pipe(filter((message: any) => message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
      takeUntil(this._destroying$)).subscribe((message: any) => {
        const dbaPayloadData = message.payload.accessToken;
        console.log(dbaPayloadData, 'authResult');
        if (dbaPayloadData) {
          //const result = dbaPayloadData.accessToken;
          localStorage.setItem("dbamsaltoken", message.payload.accessToken);
        }
      });
      

      this.msalService.handleRedirectObservable().subscribe({
        next: (dbaPayloadData: any | null) => {
          if (dbaPayloadData.accessToken) {
            ///const result = response.accessToken;
            localStorage.setItem("dbamsaltoken", dbaPayloadData.accessToken);
          }
        },
        error: (error) => {
          console.error('Redirect handling failed:', error)
        }
      });

      this.userIdle.startWatching();

      // Start watching when user idle is starting.
      this.userIdle.onTimerStart().subscribe();

      // Start watch when time is up.
      this.userIdle.onTimeout().subscribe(() => this.router.navigate(['sessionexpired']));

      const selectedInfra = localStorage.getItem('selectedInfra');
      if (selectedInfra && selectedInfra.split(',').length === 3) {
        this.isregionselected = true;
      }


      if (this.viewEngagementCountryId != undefined && this.viewEngagementCountryId != null && this.viewEngagementCountryId != "null"
        && this.viewEngagementCountryId != "undefined") {
        this.signIn('wb', 0, '');
      }
      else if (!this.isregionselected) {
        this.signIn('dba', 0, '');
      }

      else {
        if (location.pathname == '/')
          location.href = '/home';
      }


    }
  }

  signIn(loginType: string, dCountryId: number, dProjectId: string) {
    const accountDetail = this.msalService.instance.getAllAccounts()[0];
    if (accountDetail) {
      this.loginSucessService(loginType, dCountryId, dProjectId);
    } else {
      localStorage.clear();
      var cid = this.viewEngagementCountryId;
      var eid = this.viewEngagementEngagementId;

      localStorage.setItem('WBcountryId', cid);
      localStorage.setItem('WBEngagementId', eid);
     

      this.msalService.loginRedirect();
    }
  }

  private loginSucessService(loginType: string, dcountryId: number, dProjectId: string) {
    //this.broadcastService.subscribe('msal:loginSuccess', () => {
    if (loginType === 'daisey') {
      this.countryService.getcountrylist().subscribe((data: Country[]) => {
        this.countrylist = data;
        const country = this.countrylist.find(el => el.Id === dcountryId);
        const dRegionId = country.InfraId.toString();
        localStorage.setItem('selectedInfra', +dcountryId + ',0,' + dRegionId);
        this.infraService.setInfraDetails(`${dcountryId},0,${dRegionId}`);
        this.isregionselected = true;

        this.getEngagementId(dProjectId, dRegionId);
      });
    }
    else if (loginType === 'wb') {
      var region = '';
      this.countryService.getcountrylist().subscribe((data: Country[]) => {
        this.countrylist = data;
        localStorage.removeItem('selectedInfra');
        var countryId = this.viewEngagementCountryId != undefined ? Number(this.viewEngagementCountryId) : 0;
        const country = this.countrylist.find(el => el.Id === countryId);
        const dRegionId = country ? country.InfraId.toString() : 0;
        localStorage.setItem('selectedInfra', +countryId + ',0,' + dRegionId);
        this.infraService.setInfraDetails(`${countryId},0,${dRegionId}`);
        this.isregionselected = true;
        this.wbAuthenticateUser();

      });

    } else {
      this.countryService.getcountrylist().subscribe((data: Country[]) => {
        this.countryLoaded = true;
        this.countrylist = data;
        this.countryDropdownList = this.countrylist.map(x => ({
          label: x.Country,
          code: x.CountryCode,
          value: x.Id + ',' + x.TemplateId + ',' + x.InfraId
        }));
      });
    }

  }

  // splitUpString();
  private getEngagementId(dProjectId, dRegionId) {
    this.engagementService.GetEngagementBasedOndaiseyProjectId(dProjectId)
      .subscribe((data: any) => {
        const engId = data.Id;

        if (data.reportingCurrencyId > 0 && data.countryId > 0 && data.templateId > 0) {
          const selectedInfra = `${data.countryId},${data.templateId},${dRegionId}`;
          this.infraService.setInfraDetails(selectedInfra);
          localStorage.setItem('selectedInfra', selectedInfra);
          setTimeout(() => { this.router.navigate(['/viewengagement', engId]); }, 500);
        } else {
          this.router.navigate(['/editengagement', engId]);
        }
      }, error => {

      });
  }

  Go(event) {
    if (this.selectedInfra.value !== '0,0,0') {
      this.loadspinner = true;
      const infraDetails = this.selectedInfra.value;
      localStorage.setItem('selectedInfra', this.selectedInfra.value);
      this.infraService.setInfraDetails(infraDetails);
      setTimeout(() => {
        this.authenticateUser();
      }, 1000);
    } else {
      this.messageService.add({
        key: 'myKey1', severity: 'Failed',
        summary: 'Please select region', detail: 'Region is required.'
      });
    }
  }

  authenticateUser() {
    this.loadspinner = true;
    if (this.msalService.instance.getAllAccounts()[0] == null) {
      this.signIn('dba', 0, '');
    }

    this.forAuthorizedUser = true;
    location.href = '/home';
    localStorage.setItem('RegionChanged', 'false');
    this.loadspinner = false;
  }

  wbAuthenticateUser() {
    this.loadspinner = true;
    if (this.msalService.instance.getAllAccounts()[0] == null) {
      this.signIn('dba', 0, '');
    }

    this.forAuthorizedUser = true;
    if (this.viewEngagementEngagementId != undefined && this.viewEngagementCountryId != undefined) {
      this.router.navigate(['/viewengagement', this.viewEngagementEngagementId, this.viewEngagementCountryId]);
      localStorage.clear();
    }
    this.loadspinner = false;
  }
  showDialog() {
    this.display = true;
    // this.countryService.getCountry().
    //  then(countries => this.countries = countries);
  }
  public getCountryFlagClassName(country) {
    if (country.code !== undefined && country.code !== null) {
      return 'flag-icon-' + country.code.toLowerCase();
    }
    return '';
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  @HostListener('document:visibilitychange', ['$event'])
  onvisibilitychange(event: any): void {
    if (document.visibilityState === 'visible') {
      const changedRegion = (localStorage.getItem('selectedInfra')) ? localStorage.getItem('selectedInfra').split(',')[2].trim() : null;
      this.infraService.infraDetails$.subscribe(data => {
        if (data.InfraId && String(data.InfraId) !== changedRegion) {
          location.href = '/home';
          this.router.navigate(['/home']);
        }
      });
    }
  }
}
